/* import __COLOCATED_TEMPLATE__ from './pill.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { IntegrationState } from 'embercom/objects/standalone/constants';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';
import type IntlService from 'ember-intl/services/intl';
import type SalesforceConfiguration from 'embercom/models/standalone/salesforce-configuration';

export interface Args {}

export default class Pill extends Component<Args> {
  @service declare finStandaloneService: FinStandaloneService;
  @service declare intl: IntlService;

  get salesforceConfig(): SalesforceConfiguration | undefined {
    return this.finStandaloneService.salesforceConfig;
  }

  get integrationState(): IntegrationState {
    return this.salesforceConfig?.status ?? IntegrationState.NotConfigured;
  }

  get stampText() {
    switch (this.integrationState) {
      case IntegrationState.Enabled:
        return this.intl.t('standalone.deploy.salesforce.cases.integration-state.live');
      case IntegrationState.Paused:
        return this.intl.t('standalone.deploy.salesforce.cases.integration-state.paused');
      case IntegrationState.Created:
        return this.intl.t('standalone.deploy.salesforce.cases.integration-state.setting-up');
      default:
        return this.intl.t('standalone.deploy.salesforce.cases.integration-state.not-set-up');
    }
  }

  get stampColor() {
    switch (this.integrationState) {
      case IntegrationState.Enabled:
        return 'green';
      case IntegrationState.Paused:
        return 'yellow';
      default:
        return 'gray';
    }
  }

  get stampIcon() {
    switch (this.integrationState) {
      case IntegrationState.Enabled:
        return 'rounded-check';
      case IntegrationState.Paused:
        return 'pause';
      case IntegrationState.Created:
        return 'wait';
      default:
        return undefined;
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Deploy::Salesforce::Cases::Pill': typeof Pill;
    'standalone/deploy/salesforce/cases/pill': typeof Pill;
  }
}
